module.exports = __webpack_public_path__ + "img/creamer.98371c3e.jpg";